import { createContext } from "react";

const DarkModeContext = createContext();

export default DarkModeContext;